// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kVQapHbeXTOkTD2ld_qh0","table":"_3bHMb-S_tAY8zmKTIz9M_t"};